import { render, staticRenderFns } from "./DischargesForm.vue?vue&type=template&id=51c9ecf3&"
import script from "./DischargesForm.vue?vue&type=script&lang=js&"
export * from "./DischargesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports